module.exports = __webpack_public_path__ + "static/round3_poster-a2bab4f8da4fa9d4e96621f4eec94908.jpg";